export { default } from './Header';

require('./header.scss');